import useScrollReveal from "../../hooks/useScrollReveal"
import "./Projects.css"

const Projects = ({ language }) => {
  useScrollReveal(".project-card")

  const projectsData = {
  en: [
    {
      title: "Katsina Road Expansion",
      description:
        "In July 2025, the Kano State Executive Council approved a ₦24.7 billion investment for the expansion of Katsina Road, from Baban Gwari Roundabout to Mil Tara. The project includes constructing five new pedestrian bridges to improve traffic flow and pedestrian safety."
    },
    {
      title: "Flyovers and Underpasses",
      description:
        "Major interchanges, including the Tal'udu and Dan'agundi flyovers, are being constructed to address urban traffic congestion. Another prominent project is the Abundi flyover and underpass, valued at several billion naira, which was awarded in December 2023."
    },
    {
      title: "Road Rehabilitation",
      description:
        "The administration is rehabilitating 17 dilapidated roads in the Kano metropolis as part of its urban renewal initiative. Roads from Mumbayya House to Tal'udu Junction, Gadon Kaya, Yahaya Gusau Road, and Sharada Road received a ₦5.4 billion investment for rehabilitation and asphalt overlay."
    },
    {
      title: "Rural Access Roads",
      description:
        "In September 2025, the governor flagged off the construction of 70 kilometers of rural access roads in collaboration with the Islamic Development Bank (IsDB) and the Lives and Livelihood Fund (LLF). Earlier in 2025, a 9-kilometer road was commissioned in Rogo Local Government to improve market access for farmers."
    },
    {
      title: "Market Redevelopment",
      description:
        "Following fire incidents, the Farm Centre GSM Market is being redeveloped with a ₦2 billion investment. This includes expanding the market and adding essential infrastructure like a fire station, solar streetlights, drainage, and improved roads to create an international trading hub."
    },
    {
      title: "Water Supply",
      description:
        "The government has made significant investments to address water scarcity. This includes payments for energy bills for the regional water supply scheme and reviving the Tamburawa Water Plant by procuring new pumping machines."
    },
    {
      title: "Renewable Energy",
      description:
        "The administration is upgrading energy infrastructure. In April 2025, ₦1.46 billion was approved for the Ministry of Power and Renewable Energy. The government also installed solar energy systems in five maternity facilities across the state."
    },
    {
      title: "Relief Disbursement",
      description:
        "Governor Abba Kabir Yusuf took a bold step toward engaging youth by launching the disbursement of the first tranche of the Kano State Youth Empowerment Programme. This programme supports young entrepreneurs with ₦150,000 each to start or expand their businesses, empowering 5,384 youths."
    },
    {
      title: "Upgrading Educational Facilities",
      description:
        "As part of a declared 'State of Emergency on Education,' over ₦4.8 billion was approved for renovating existing classrooms and constructing new ones across the 44 local government areas. In April 2025, the state budget allocated 31% to education, surpassing UNESCO recommendations."
    },
    {
      title: "Support for Teachers and Students",
      description:
        "The government has recruited thousands of teachers yearly and provided free uniforms, textbooks, benches, and chairs to pupils. A ₦200 million vehicle loan scheme was also implemented to improve teachers' welfare."
    },
    {
      title: "Reactivating Abandoned Projects",
      description:
        "The administration is committed to completing educational projects initiated by previous administrations but later abandoned. This includes completing renovations at the French and Chinese Bilingual Colleges and upgrading the School for Islamic Studies."
    },
    {
      title: "Scholarship Schemes",
      description:
        "The government has revived its foreign scholarship program, sponsoring 1,001 postgraduate students abroad. It has also cleared outstanding school fees for students in foreign and local tertiary institutions."
    },
    {
      title: "Gender Equality in Education",
      description:
        "Special focus has been given to girls' education through the reopening of closed all-girls' boarding schools and providing dedicated transport to increase enrollment and reduce dropout rates."
    },
    {
      title: "Primary Healthcare (PHC) Revitalization",
      description:
        "In August 2025, a major project was launched to renovate and equip 187 Primary Healthcare Centres across all 44 local government areas. This follows a decision in July 2025 to renovate 203 dilapidated PHCs under the IMPACT Project."
    },
    {
      title: "Upgrading Hospitals",
      description:
        "Hospitals like Murtala Muhammad Specialist Hospital, Nuhu Bamalli Hospital, and Muhammad Abdullahi Wase Teaching Hospital are being upgraded with digital X-ray machines and modern equipment."
    },
    {
      title: "Disease Prevention and Free Healthcare",
      description:
        "The government provides free antenatal care, delivery kits, and subsidized healthcare for the public, including prisoners. Disease prevention and free medical tests are also ongoing."
    },
    {
      title: "Maternal and Child Health",
      description:
        "₦180 million was allocated for the Free Maternal, Neonatal, and Child Health program. In December 2024, the government distributed essential supplies such as delivery and Caesarean section kits."
    },
    {
      title: "Youth Empowerment",
      description:
        "The administration launched the 'Abba Gida Gida Mass Transport Empowerment and Employment Programme,' which includes procuring 500 electric tricycles worth ₦3.7 billion. Over 1,130 graduates received start-up kits."
    },
    {
      title: "Agricultural Support",
      description:
        "The government invested heavily in agricultural development through KSADP, rural road construction, irrigation projects, and recruitment of 1,038 young agricultural extension officers under KNARDA."
    },
    {
      title: "Welfare Payments",
      description:
        "The government is clearing a ₦48 billion backlog of pensions and gratuities, with ₦27 billion already disbursed, while also providing financial aid to small business owners."
    },
    {
      title: "Fifth Tranche of Gratuities",
      description:
        "Governor Abba Kabir released ₦5 billion as the fifth tranche of gratuities for retired civil servants, bringing total payments to ₦27 billion from a ₦48 billion backlog."
    },
    {
      title: "Job Creation",
      description:
        "Governor Abba Kabir Yusuf distributed empowerment packages to 1,130 graduates from six entrepreneurship institutes — including laptops, phone repair kits, bulls, tools, and digital cameras."
    },
    {
      title: "Support for Afforestation",
      description:
        "The governor launched the distribution of 5.5 million tree seedlings for planting across the state’s 44 LGAs, promoting environmental conservation."
    },
    {
      title: "Support for Electrification",
      description:
        "Governor Abba Kabir Yusuf distributed 500 electricity transformers across the state to improve power supply, marking the first phase of community electrification."
    },
    {
      title: "Subsidized Fertilizer",
      description:
        "The governor launched fertilizer distribution at 50% discount — three trucks (600 bags each) per LGA — totaling 79,200 bags to boost food production and economic growth."
    },
    {
      title: "Creation of Garment Industry",
      description:
        "The administration is reopening the garment industry to create 63,360 jobs annually across all 44 LGAs, providing an average monthly income of ₦70,000 per worker."
    },
    {
      title: "Kano Metropolitan Solar Streetlights Initiative",
      description:
        "This flagship urban renewal project replaces diesel streetlights with solar-powered alternatives across all major roads and metropolitan areas."
    },
    {
      title: "Kano State Hospital Solarization Initiative",
      description:
        "The ‘Light for Life’ initiative ensures 24/7 power for state hospitals using solar energy, enhancing healthcare quality and sustainability."
    },
    {
      title: "Youth Agribusiness Empowerment with ₦400 Million",
      description: "Disbursed ₦400 million to 10 community interest groups for agribusiness ventures, with each group receiving ₦40 million ($25,000) and individuals getting at least ₦1 million startup capital through ACReSAL and World Bank collaboration."
    },
    {
      title: "Garment Industry Revival Creating 63,360 Jobs",
      description: "Reopened Kura Garment Industry to create 63,360 jobs across 44 LGAs, providing average monthly income of ₦70,000, fulfilling campaign promises."
    },
    {
      title: "₦5 Billion Gratuity Payment to Pensioners",
      description: "Launched third phase of gratuity payments totaling ₦5 billion, bringing total disbursements to ₦16 billion for Kano's retirees."
    },
    {
      title: "Health Centers Upgrade and Infrastructure Approvals",
      description: "Approved upgrade of primary health centers to general hospitals in Gabasawa, Kiru, and Shanono for ₦920,960,250.9, establishment of Government Girls Secondary School for ₦411,411,830.39, and reconstruction of Rogo-Bari-Falgore-Mahangi road for ₦13,350,209,134.89."
    },
    {
      title: "150 Postgraduate Scholars Return from India",
      description: "Welcomed 150 Kano youths back from master's programs in India under the 1001 foreign postgraduate scholarship, with automatic employment in engineering, medicine, and health fields."
    },
    {
      title: "Abba Care Initiative and Immunization Revival",
      description: "Launched Abba Care free health insurance covering over 300,000 marginalized individuals, reinstated routine immunizations abandoned for 18 months, and pledged state-of-the-art sickle cell clinic at Murtala Muhammad Specialist Hospital."
    },
    {
      title: "₦2 Billion Tuition Debt Reduction",
      description: "Negotiated ₦2 billion reduction in tuition liabilities to Near East University, settling at ₦1.9 billion for 50 sponsored students who returned without certificates."
    },
    {
      title: "Tudun Yola Road and Rijiyar Lemo Network Construction",
      description: "Approved construction of Tudun Yola off Gwarzo-Bypass for ₦1.8 billion and Rijiyar Lemo Road Network for ₦497 million."
    },
    {
      title: "Football Kits Distribution to 600 Clubs",
      description: "Distributed football kits to 600 clubs across Kano to encourage youth development in sports, alongside stadium renovations and talent scouting plans."
    },
    {
      title: "₦71,000 Minimum Wage Implementation",
      description: "Approved ₦71,000 minimum wage effective November, increasing state obligations by ₦6 billion and LGAs by ₦7 billion, with teacher promotions adding ₦340 million."
    },
    {
      title: "Airport Gate Road Rehabilitation for ₦5.6 Billion",
      description: "Approved rehabilitation of Airport Gate-Triumph Roundabout-Murtala Muhammad Way Flyover-KSIP Roundabout for ₦5,628,970,300.20 and Muhammadu Buhari Road for ₦4,108,966,050."
    },
    {
      title: "78 Patrol Vehicles for Police Command",
      description: "Handed over 78 patrol vehicles (44 Hilux, 34 vans) to Kano Police across 44 LGAs to enhance security."
    },
    {
      title: "Kano Informatics Institute Reopening",
      description: "Reopened Kano Informatics Institute with 250 intakes, purchased 50 staff quarters, and committed to digital economy advancement."
    },
    {
      title: "₦99 Billion Supplementary Budget Signed",
      description: "Signed ₦99,221,503,569.93 supplementary budget for 2024, covering minimum wage, elections, school uniforms, and project reviews, bringing total budget to ₦536,559,816,357.84."
    },
    {
      title: "Kafinchiri Irrigation Project for ₦2.5 Billion",
      description: "Conducted on-site assessment of ₦2.5 billion Kafinchiri Irrigation Project in Garko LGA for year-round farming, food security, and economic growth."
    },
    {
      title: "52,800 Bags of Free Fertilizer Distribution",
      description: "Flagged off distribution of 52,800 free NPK fertilizer bags worth ₦1 billion to smallholder farmers across 44 LGAs, produced by KASCO."
    }
  ],

  ha: [
    {
      title: "Faɗaɗawar Katsina Road",
      description:
        "A cikin Janairu 2025, Kano State Executive Council ya amince da saka jari na ₦24.7 billion don faɗawar Katsina Road, daga Baban Gwari Roundabout zuwa Mil Tara. Aiki ya haɗa da gina gada biyar don inganta tafiya da tsaro."
    },
    {
      title: "Flyovers da Underpasses",
      description:
        "Manyan gada, kamar Tal’udu da Dan’agundi flyovers, ana gina su don magance cunkoson hanyoyi. Wani aiki mai daraja shine Abundi flyover da underpass da aka ba a Disamba 2023."
    },
    {
      title: "Gyaran Hanya",
      description:
        "Gwamnati ta fara gyaran hanyoyi 17 da suka lalace a Kano metropolis don sabuntawa. Hanyoyi daga Mumbayya House zuwa Tal’udu Junction da Sharada Road sun samu ₦5.4 billion don asphalt overlay."
    },
    {
      title: "Hanyoyin Kauyuka",
      description:
        "A cikin Satumba 2025, Gwamna ya kaddamar da gina hanyoyi 70km na kauyuka tare da Islamic Development Bank. An gama hanya 9km a Rogo LGA don taimakawa manoma."
    },
    {
      title: "Sabunta Kasuwanni",
      description:
        "Bayan gobara, Farm Centre GSM Market ana sake ginawa da ₦2 billion, tare da hasken rana, magudanar ruwa, da ƙarin kayan more rayuwa."
    },
    {
      title: "Ruwan Sha",
      description:
        "Gwamnati ta saka jari wajen dawo da Tamburawa Water Plant da kuma biya wutar lantarki don tsarin ruwan yankin."
    },
    {
      title: "Makamashi Mai Sabuntawa",
      description:
        "A cikin Afirilu 2025, an amince da ₦1.46 billion don inganta sashen makamashi, tare da saka hasken rana a asibitoci biyar."
    },
    {
      title: "Rarraba Tallafi",
      description:
        "Gwamna Abba Kabir Yusuf ya kaddamar da rabon tallafin matasa na farko inda matasa 5,384 suka karɓi ₦150,000 kowannensu don kasuwanci."
    },
    {
      title: "Inganta Makarantu",
      description:
        "An amince da fiye da ₦4.8 billion don gyaran dakunan karatu da gina sababbi a LGAs 44, tare da kasafin kudi na 31% ga ilimi."
    },
    {
      title: "Goyon Bayan Malamai da Dalibai",
      description:
        "Gwamnati ta ɗauki malamai dubu-dubu, ta bayar da kayan karatu, da kuma tsarin bashi na mota ₦200 million."
    },
    {
      title: "Farfado da Ayyuka da Aka Watsar",
      description:
        "Gwamnati ta himmatu wajen kammala ayyukan ilimi da aka fara amma aka watsar, ciki har da gyaran makarantun Bilingual."
    },
    {
      title: "Tsarin Tallafin Karatu",
      description:
        "An dawo da tsarin tallafin karatu na ƙasashen waje, inda dalibai 1,001 ke samun tallafi a fannoni daban-daban."
    },
    {
      title: "Ilimin ’Yan Mata",
      description:
        "An buɗe makarantun ’yan mata da aka rufe tare da samar da motocin sufuri don rage fita daga makaranta."
    },
    {
      title: "Gyaran Cibiyoyin Lafiya",
      description:
        "A cikin Agusta 2025, an kaddamar da gyaran cibiyoyin lafiya 187 a duk LGAs 44."
    },
    {
      title: "Inganta Asibitoci",
      description:
        "Asibitoci kamar Murtala, Nuhu Bamalli da Wase Teaching Hospital suna samun sabbin kayan aiki."
    },
    {
      title: "Kariya da Lafiya Kyauta",
      description:
        "Gwamnati na bayar da jinya kyauta ga mata masu juna biyu, fursunoni, da masu fama da cututtuka."
    },
    {
      title: "Lafiyar Uwa da Yara",
      description:
        "An ware ₦180 million don jinya kyauta ga mata masu ciki da jarirai, tare da kayan haihuwa."
    },
    {
      title: "Karfafa Matasa",
      description:
        "An kaddamar da shirin tricycle 500 na lantarki mai daraja ₦3.7 billion da kayan farawa ga dalibai 1,130."
    },
    {
      title: "Tallafin Noma",
      description:
        "An saka jari cikin KSADP da hanyar kasuwa, da daukar ma’aikatan gonaki 1,038 a KNARDA."
    },
    {
      title: "Tallafin Ma’aikata",
      description:
        "An biya ₦27 billion daga ₦48 billion da ake binsu a matsayin fansho da gratuity, da kuma tallafi ga ’yan kasuwa."
    },
    {
      title: "Rabo na Biyar na Gratuities",
      description:
        "Gwamna Abba Kabir ya saki ₦5 billion a matsayin rabo na biyar na fansho ga tsofaffin ma’aikata."
    },
    {
      title: "Ƙirƙirar Ayyuka",
      description:
        "An raba kayan aiki ga dalibai 1,130 daga cibiyoyi 6, ciki har da kwamfutoci, kayan gyaran waya, da bijimai."
    },
    {
      title: "Shirin Dasa Bishiyoyi",
      description:
        "An kaddamar da rabon bishiyoyi miliyan 5.5 don dasa su a duk LGAs 44."
    },
    {
      title: "Tallafin Wutar Lantarki",
      description:
        "An rarraba transformers 500 don inganta wutar lantarki a dukkan jihar."
    },
    {
      title: "Rangwamen Taki",
      description:
        "An rarraba taki da kashi 50% rangwame, manyan motoci 3 ga kowace LGA don karfafa noma."
    },
    {
      title: "Masana’antar Tufafi",
      description:
        "An buɗe masana’antar tufafi don samar da ayyuka 63,360 a kowace shekara, da albashin ₦70,000."
    },
    {
      title: "Hasken Titin Kano",
      description:
        "An fara shirin sauya fitilun diesel zuwa na hasken rana a manyan hanyoyin Kano."
    },
    {
      title: "Shirin Asibitocin Hasken Rana",
      description:
        "An kaddamar da shirin samar da wutar lantarki 24/7 a asibitocin jihar ta hanyar hasken rana."
    },
    {
      title: "Ƙarfafa Matasa a Sana'ar Noma da ₦400 Miliyan",
      description: "An rarraba ₦400 miliyan ga ƙungiyoyi 10 na sha'awar al'umma don sana'ar noma, tare da kowace ƙungiya ta karɓi ₦40 miliyan ($25,000) kuma mutane su karɓi aƙalla ₦1 miliyan babban jari ta hanyar haɗin gwiwar ACReSAL da Bankin Duniya."
    },
    {
      title: "Dawo da Sana'ar Tufafi don Ƙirƙirar Ayyuka 63,360",
      description: "An buɗe sana'ar tufafi ta Kura don ƙirƙirar ayyuka 63,360 a duk LGAs 44, tare da samar da albashin ₦70,000 kowace wata, ciki har da cika alkawuran yakin neman zabe."
    },
    {
      title: "Biyan Fansho ₦5 Biliyan ga Masu Fansho",
      description: "An kaddamar da rabo na uku na biyan fansho jimlar ₦5 biliyan, wanda ya kawo jimlar kuɗi da aka rarraba zuwa ₦16 biliyan ga tsofaffin ma'aikatan Kano."
    },
    {
      title: "Haɓaka Cibiyoyin Lafiya da Amincewa da Abubuwan Gine-gine",
      description: "An amince da haɓaka cibiyoyin lafiya na farko zuwa asibitoci na gabaɗaya a Gabasawa, Kiru, da Shanono don ₦920,960,250.9, kafa makarantar sakandare ta mata ta gwamnati don ₦411,411,830.39, da sake gina titin Rogo-Bari-Falgore-Mahangi don ₦13,350,209,134.89."
    },
    {
      title: "Dalibai 150 na Postgraduate Sun Dawo daga Indiya",
      description: "An yi maraba ga matasan Kano 150 da suka dawo daga shirye-shiryen master a Indiya a ƙarƙashin tallafin ƙasashen waje na 1001, tare da aiki ta atomatik a fannoni na injiniya, likitanci, da lafiya."
    },
    {
      title: "Shirin Abba Care da Dawo da Allurar Riguwa",
      description: "An kaddamar da shirin Abba Care na inshorar lafiya kyauta wanda ya shafi sama da mutane 300,000 da suka raunana, an dawo da allurar yau da kullum da aka watsar na watanni 18, kuma an yi alkawari na gina asibitin sickle cell na zamani a Asibitin Murtala Muhammad Specialist."
    },
    {
      title: "Rage Bashi na Koyarwa ₦2 Biliyan",
      description: "An yi shawarwari don rage bashin koyarwa ₦2 biliyan zuwa Jami'ar Near East, tare da daidaita a ₦1.9 biliyan ga dalibai 50 da aka tallafa wa suka dawo ba tare da takaddun su ba."
    },
    {
      title: "Gina Titin Tudun Yola da Rijiyar Lemo Network",
      description: "An amince da gina Tudun Yola daga Gwarzo-Bypass don ₦1.8 biliyan da Rijiyar Lemo Road Network don ₦497 miliyan."
    },
    {
      title: "Rarraba Kayan Kwallon Ƙafa ga Ƙungiyoyi 600",
      description: "An rarraba kayan kwallon ƙafa ga ƙungiyoyi 600 a fadin Kano don ƙarfafa ci gaban matasa a wasanni, tare da gyaran filin wasa da shirye-shiryen nemo talenta."
    },
    {
      title: "Aiwatar da Mafi Ƙarancin Albashi ₦71,000",
      description: "An amince da mafi ƙarancin albashi ₦71,000 wanda zai fara aiki a watan Nuwamba, yana ƙara wajibcin jihar ₦6 biliyan da LGAs ₦7 biliyan, tare da haɓaka malamai ya ƙara ₦340 miliyan."
    },
    {
      title: "Gyaran Titin Airport Gate don ₦5.6 Biliyan",
      description: "An amince da gyaran titin Airport Gate-Triumph Roundabout-Murtala Muhammad Way Flyover-KSIP Roundabout don ₦5,628,970,300.20 da titin Muhammadu Buhari don ₦4,108,966,050."
    },
    {
      title: "Motocin Garda 78 ga Kwamandan 'Yan Sanda",
      description: "An mika motocin garda 78 (Hilux 44, van 34) ga 'Yan Sandan Kano a duk LGAs 44 don haɓaka tsaro."
    },
    {
      title: "Buɗe Cibiyar Bayanai ta Kano",
      description: "An buɗe Cibiyar Bayanai ta Kano tare da shigarwa 250, an saya gidaje 50 na ma'aikata, kuma an himmatu ga ci gaban tattalin arziƙin dijital."
    },
    {
      title: "An Sa hannu kan Kasafin Ƙarin ₦99 Biliyan",
      description: "An sa hannu kan kasafin ƙarin ₦99,221,503,569.93 na 2024, wanda ya shafi mafi ƙarancin albashi, zaɓe, kayan makaranta, da sake duba ayyuka, wanda ya kawo jimlar kasafin zuwa ₦536,559,816,357.84."
    },
    {
      title: "Aikin Ban Ruwa na Kafinchiri don ₦2.5 Biliyan",
      description: "An gudanar da bincike a wurin na aikin ban ruwa na Kafinchiri na ₦2.5 biliyan a Garko LGA don noma tsawon shekara, tsaron abinci, da ci gaban tattalin arziƙin."
    },
    {
      title: "Rarraba Jakunkuna 52,800 na Taki Kyauta",
      description: "An kaddamar da rarraba jakunkuna 52,800 na taki NPK kyauta mai daraja ₦1 biliyan ga ƙananan manoma a duk LGAs 44, wanda aka samar da KASCO."
    }
  ]
};




  const currentProjects = projectsData[language]

  return (
    <div className="projects">
      <div className="projects-header">
        <h1>{language === "en" ? "Top Projects" : "Manyyan Ayyukanmu"}</h1>
      </div>

      <div className="projects-container">
        <div className="projects-grid">
          {currentProjects.map((project, index) => (
            <div key={index} className="project-card scroll-reveal slide-left" style={{ animationDelay: `${index * 0.1}s` }}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Projects
